import React from 'react';
import { Drawer, List, IconButton, withStyles } from '@material-ui/core';

import * as Icons from '@material-ui/icons';
import classNames from 'classnames';
import { withTranslation } from 'react-i18next';
import presenseLogo from '../../images/Presense/Logo/presense-alternate-logo.png';
import IconHeart from '../../images/Presense/Icon/heart.png';

import SidebarLink from './components/SidebarLink/SidebarLinkContainer';
import { checkByRole } from '../../utils/handleSidebar';

const SidebarView = ({
  classes,
  // theme,
  toggleSidebar,
  seletedSidebarMenus,
  isSidebarOpened,
  mouseOverSidebar,
  mouseOUTSidebar,
  // isPermanent,
  location,
  props,
}) => {
  const { t, screen } = props;
  let structure = [
    {
      id: 0,
      label: t('dashboard'),
      link: '/app/dashboard',
      icon: <Icons.Home />,
    },
    {
      id: 1,
      label: t('all_patients'),
      link: '/app/allpatients',
      icon: <Icons.SupervisorAccountOutlined />,
    },
    {
      id: 2,
      label: t('usage_summary'),
      link: '/app/usagesummary',
      icon: <Icons.ViewHeadline />,
    },
    { id: 3, type: 'divider' },
    { id: 4, type: 'title', label: t('devices_routers') },
    { id: 5, label: t('management_wizard'), link: '/app/wizard', icon: <Icons.Dashboard /> },
    { id: 6, label: t('device'), link: '/app/devices', icon: <Icons.Memory /> },
    {
      id: 7,
      label: t('device_type'),
      link: '/app/devicetype',
      icon: <Icons.DevicesOther />,
    },
    { id: 8, label: t('router'), link: '/app/routers', icon: <Icons.Router /> },
    {
      id: 9,
      label: t('router_type'),
      link: '/app/routertype',
      icon: <Icons.Router />,
    },
    { id: 10, type: 'divider' },
    { id: 11, type: 'title', label: t('location') },
    {
      id: 12,
      label: t('location'),
      link: '/app/locations',
      icon: <Icons.Map />,
    },
    { id: 13, label: t('map'), link: '/app/maps', icon: <Icons.MapOutlined /> },
    {
      id: 14,
      label: t('group'),
      link: '/app/groups',
      icon: <Icons.LocationCity />,
    },
    {
      id: 15,
      label: t('module'),
      link: '/app/modules',
      icon: <Icons.LocationSearching />,
    },
    { id: 16, label: t('area'), link: '/app/areas', icon: <Icons.Business /> },
    { id: 17, type: 'divider' },
    { id: 18, type: 'title', label: t('people') },
    {
      id: 19,
      label: t('user'),
      link: '/app/users',
      icon: <Icons.SupervisorAccount />,
    },
    {
      id: 20,
      label: t('role'),
      link: '/app/roles',
      icon: <Icons.RecentActors />,
    },
    {
      id: 21,
      label: t('patient'),
      link: '/app/patients',
      icon: <Icons.Hotel />,
    },
    {
      id: 22,
      label: t('alert_profile'),
      link: '/app/alertprofile',
      icon: <Icons.AccessibilityNew />,
    },
    // { id: 19, label: 'Questionnaire', link: '/app/questionnaires', icon: <Icons.QuestionAnswer /> },
    // {
    //   id: 12,
    //   label: 'UI Elements',
    //   link: '/app/ui',
    //   icon: <UIElementsIcon />,
    //   children: [
    //     { label: 'Icons', link: '/app/ui/icons' },
    //     { label: 'Charts', link: '/app/ui/charts' },
    //     { label: 'Maps', link: '/app/ui/maps' },
    //   ],
    // },
  ];

  const displayedMenus = checkByRole(localStorage.getItem('role'));
  structure = structure.filter((s) => displayedMenus.includes(s.id));
  return (
    <Drawer
      // variant={isPermanent ? "permanent" : "temporary"}
      // variant={localStorage.getItem("role_id") === "1" ? "permanent" : "temporary"}
      variant={displayedMenus.length > 0 ? 'permanent' : 'temporary'}
      className={classNames(classes.drawer, {
        [classes.drawerOpen]: isSidebarOpened,
        [classes.drawerClose]: !isSidebarOpened,
      })}
      classes={{
        paper: classNames({
          [classes.drawerOpen]: isSidebarOpened,
          [classes.drawerClose]: !isSidebarOpened,
          [classes.displayDrawer]: !screen.activeFullScreen,
          [classes.hideDrawer]: screen.activeFullScreen,
        }),
      }}
      open={isSidebarOpened}
      anchor='left'
      // onMouseOver={mouseOverSidebar}
      // onMouseLeave={mouseOUTSidebar}
    >
      {/* <Drawer
        className={classNames(classes.drawer, {
          [classes.drawerOpen]: isSidebarOpened,
          [classes.drawerClose]: !isSidebarOpened,
        })}
        variant="persistent"
        anchor="left"
        open={isSidebarOpened}
        classes={{
          paper: classNames({
            [classes.drawerOpen]: isSidebarOpened,
            [classes.drawerClose]: !isSidebarOpened,
          }),
        }}
      > */}
      <div className={classes.toolbar}>
        {isSidebarOpened ? (
          <div>
            <IconButton className={classes.iconBack} onClick={toggleSidebar}>
              <svg width='26' height='26' viewBox='0 0 26 26'>
                <use xlinkHref={`/images/header.svg#expandmenus`} />
              </svg>
            </IconButton>
            <img src={presenseLogo} alt='logo' className={classes.logo} />
          </div>
        ) : (
          <img src={IconHeart} alt='heart' width='24' height='21' />
        )}
      </div>
      {/* <div className={classes.mobileBackButton}>
        <IconButton onClick={toggleSidebar}>
          <Icons.ArrowBack
            classes={{
              root: classNames(classes.headerIcon, classes.headerIconCollapse),
            }}
          />
        </IconButton>
      </div> */}
      <div onMouseOver={mouseOverSidebar} onMouseLeave={mouseOUTSidebar}>
        <List className={classes.sidebarList}>
          {structure.map((link) => (
            <SidebarLink
              key={link.id}
              location={location}
              isSidebarOpened={isSidebarOpened}
              seletedSidebarMenus={seletedSidebarMenus}
              {...link}
            />
          ))}
        </List>
      </div>
    </Drawer>
  );
};

const drawerWidth = 240;

const styles = (theme) => ({
  menuButton: {
    marginLeft: 12,
    marginRight: 36,
  },
  hide: {
    display: 'none',
  },
  drawer: {
    zIndex: 1210,
    width: drawerWidth,
    flexShrink: 0,
    whiteSpace: 'nowrap',
    position: 'fixed',
  },
  drawerOpen: {
    width: drawerWidth,
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  drawerClose: {
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    overflowX: 'hidden',
    overflowY: 'hidden',
    width: theme.spacing.unit * 5 + 4,
    // width: theme.spacing.unit,
    // [theme.breakpoints.down("sm")]: {
    //   width: drawerWidth,
    // }
  },
  displayDrawer: {
    display: 'block',
  },
  hideDrawer: {
    display: 'none',
  },
  toolbar: {
    display: 'flex',
    position: 'relative',
    justifyContent: 'center',
    alignItems: 'center',
    ...theme.mixins.toolbar,
    // [theme.breakpoints.down("sm")]: {
    //   display: "none",
    // },
  },
  content: {
    flexGrow: 1,
    padding: theme.spacing.unit * 3,
  },
  sidebarList: {
    marginTop: theme.spacing.unit * 3,
  },
  mobileBackButton: {
    marginTop: theme.spacing.unit * 0.5,
    marginLeft: theme.spacing.unit * 3,
    [theme.breakpoints.only('sm')]: {
      marginTop: theme.spacing.unit * 0.625,
    },
    [theme.breakpoints.up('md')]: {
      display: 'none',
    },
  },
  logo: {
    width: '90%',
    marginTop: 10,
  },
  iconBack: {
    right: theme.spacing.unit,
    marginTop: theme.spacing.unit * 0.5,
    position: 'absolute',
    cursor: 'pointer',
    transform: 'rotate(180deg)',
    zIndex: 1250,
  },
});
export const translation = withTranslation()(SidebarView);
export default withStyles(styles, { withTheme: true })(translation);
export const initialState = {
  isLoading: false,
  isAuthenticated: !!localStorage.getItem('id_token'),
  error: null,
};
